/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pending: NonNullable<unknown> }} Sharemonthcreditspending3Inputs */

const en_sharemonthcreditspending3 = /** @type {(inputs: Sharemonthcreditspending3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`credits this month, ${i?.pending} of them pending`)
};

const de_sharemonthcreditspending3 = /** @type {(inputs: Sharemonthcreditspending3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Credits diesen Monat, davon ${i?.pending} vorgemerkt`)
};

/**
* | output |
* | --- |
* | "credits this month, {pending} of them pending" |
*
* @param {Sharemonthcreditspending3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharemonthcreditspending3 = /** @type {((inputs: Sharemonthcreditspending3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharemonthcreditspending3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharemonthcreditspending3(inputs)
	return de_sharemonthcreditspending3(inputs)
});
export { sharemonthcreditspending3 as "shareMonthCreditsPending" }